import {Component, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {AuthenticatedUser, Club, Pager, User} from '~core/models';
import {
  ClubService,
  DefaultNotificationService,
  NavigationService,
  PaginationService,
  StorageService,
  UserManagementService,
  UserService,
} from '~core/services';
import {ClubListTranslationsService, CustomerStatusTranslationsService} from '~shared/translations';

/**
 * Component responsible for club-overview administration.
 */
@UntilDestroy()
@Component({
  selector: 'app-base-user-list',
  template: ''
})
export class BaseUserListComponent implements OnDestroy {
  public loading: boolean = true;
  public submitted: boolean = false;
  public itemsPerPage: number = 10;
  public pager: Pager;
  public listOfClubs: Array<Club>;
  public authenticatedUser?: AuthenticatedUser;

  constructor(
    public notificationService: DefaultNotificationService,
    public navigationService: NavigationService,
    public userService: UserService,
    public paginationService: PaginationService,
    public router: Router,
    public customerStatusTranslations: CustomerStatusTranslationsService,
    public clubService: ClubService,
    public clubListTranslations: ClubListTranslationsService,
    public storage: StorageService,
    public userModalService: UserManagementService,
    public flTranslations: FormLabelTranslationService,
  ) {
    if (this.storage.checkIfNotEmpty('authenticatedUser')) {
      this.storage.castAuthenticatedUser.pipe(untilDestroyed(this))
        .subscribe((user: AuthenticatedUser) => user !== null ? this.authenticatedUser = user : null);
    }
    this.clubService.castListOfClubs.pipe(untilDestroyed(this))
      .subscribe((clubs: Array<Club>) => this.listOfClubs = clubs);
  }

  /**
   * On component destroy, close the modal.
   */
  public ngOnDestroy(): void {
    this.userModalService.toggleModal(false);
  }

  /**
   * Checks your status and moves you with router link
   */
  public routerLink(user: User): void {
    const path = '/manage/users';
    if ((this.authenticatedUser.isClubAdmin) && (user.type === 'CallCenterAgent')) {
      return;
    } else {
      this.router.navigate([path, user.id]);
    }
  }
}
